
import { Component, Vue } from "vue-property-decorator";
import { refreshCurrentPage, checkIsToken } from "@/utils/token-and-router";
import { logOut } from "@/axios/request/login";

@Component
export default class Nav extends Vue {
  hasLog = checkIsToken();
  isJobPage = false;
  navSelect = this.$route.query.navSelect || this.$route.query.recruitType ||  '1';
  toLogin() {
    this.$router.push({
      path: "/login",
      query: {
        redirect: this.$route.fullPath,
      },
    });
  }
  toMine() {
    this.$router.push("/mine");
  }
  toChat() {
    this.$router.push("/chat");
  }
  async logOut() {
    this.$confirm("您即将退出当前账号，是否继续？", "退出登录", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        const { data: res } = await logOut(this.$store.state.token);
        console.log(res);
        if (res.code === 200) {
          this.$store.dispatch("setToken", {
            token: "",
          });
          window.sessionStorage.removeItem("token");
          this.$router.push("/login");
          this.$message({
            type: "success",
            message: "退出成功!",
          });
        }
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消退出操作",
        });
      });
  }
  toGree() {
    window.open("https://www.gree.com");
  }
  toHome(type: string) {
    this.navSelect = type
    this.$router.replace({
      path: '/',
      query: {
        navSelect: type
      }
    })
  }
  toCompanyIntroduce() {
    this.$router.replace({
      path: '/companyIntroduce',
      query: {
        navSelect: "3"
      }
    })
  }
  mounted() {
    this.$route.name === "Job" ? (this.isJobPage = true) : "";
  }
}
